import { render, staticRenderFns } from "./InvoicePolicyList.vue?vue&type=template&id=4efef6ac&scoped=true&"
import script from "./InvoicePolicyList.vue?vue&type=script&lang=js&"
export * from "./InvoicePolicyList.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePolicyList.vue?vue&type=style&index=0&id=4efef6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efef6ac",
  null
  
)

export default component.exports